import axios from 'axios';

import { ActivityFeedItemDto, ActivityFeedQueryParams } from '../interfaces/activity-feed-item.dto';

class ActivityFeedService {
  async getList(params: ActivityFeedQueryParams = {}): Promise<ActivityFeedItemDto[]> {
    const response = await axios.get<ActivityFeedItemDto[]>(`activity-feed/owner`, {
      params,
    });

    return response.data;
  }

  async getPropertyList(propertyId: string, params: ActivityFeedQueryParams = {}): Promise<ActivityFeedItemDto[]> {
    const response = await axios.get<ActivityFeedItemDto[]>(`activity-feed/property/${propertyId}`, {
      params,
    });

    return response.data;
  }

  async getRenterList(renterId: string, params: ActivityFeedQueryParams = {}): Promise<ActivityFeedItemDto[]> {
    const response = await axios.get<ActivityFeedItemDto[]>(`activity-feed/renter/${renterId}`, {
      params,
    });

    return response.data;
  }
}

export default new ActivityFeedService();
